import { TableBodyRow } from "@comet/admin";
import { Chip, Typography } from "@mui/material";
import { type LogMessage } from "@src/components/Type";
import styled, { css } from "styled-components";

export const StyledTypography = styled(Typography)`
    && {
        font-size: 12px;
    }
`;

export const StyledContentTypography = styled(Typography)`
    && {
        font-size: 14px;
    }
`;

export const StyledCommandTypography = styled(Typography)`
    && {
        font-size: 12px;
        color: ${({ theme }) => theme.colors.textGrey};
    }
`;

export const StyledChip = styled(Chip)`
    && {
        font-size: 12px;
        background-color: ${({ theme }) => theme.palette.primary.main};
        color: ${({ theme }) => theme.palette.primary.contrastText};
    }
`;

interface Props {
    $variant: LogMessage | string;
}

export const StyledTableBodyRow = styled(TableBodyRow)<Props>`
    && {
        ${({ $variant, theme }) => {
            switch ($variant) {
                case "SendFailure":
                case "FailedSMS":
                    return css`
                        background-color: ${theme.colors.error};
                    `;
                case "CommandInvalid":
                    return css`
                        background-color: ${theme.colors.invalid};
                    `;
                case "SendSMS":
                    return css`
                        background-color: ${theme.colors.send};
                    `;
            }
        }};
    }
`;
